import React from 'react'
import EmailSubscriptionForm from 'components/EmailSubscriptionForm'
import './styles.css'


const Email = () => (
    <section className='email-form section'>
         <EmailSubscriptionForm />
    </section>
)

export default Email
